/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nhs/location': {
    width: 18,
    height: 21,
    viewBox: '0 0 18 21',
    data: '<path pid="0" d="M14.657 14.657L10.414 18.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" _stroke="#1B365D" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M12 9a3 3 0 11-6 0 3 3 0 016 0z" _stroke="#1B365D" stroke-width="2" stroke-linecap="round" fill="none" stroke-linejoin="round"/>'
  }
})
